import faker from "@faker-js/faker";
import isValid from "date-fns/isValid/index";

export const labels = [
  0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9,
  9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5, 16, 16.5, 17,
  17.5, 18, 18.5, 19, 19.5, 20, 20.5, 21, 21.5, 22, 22.5, 23, 23.5,
];
const titleToolTip = (tooltipItems) => {
  return tooltipItems[0].label;
};
const labelToolTip = (labelToolItems) => {
  return labelToolItems.formattedValue + " RT";
};
export const options = (maxWidth765, maxWidth500, label) => {
  return {
    elements: {
      point: {
        radius: 0,
      },
    },
    hover: {
      intersect: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
      legend: {
        display: false,
      },
      tooltip: {
        caretPadding: 20,
        yAlign: "bottom",
        titleMarginBottom: 0,
        displayColors: false,
        boxWidth: 0,
        titleFont: {
          size: 13,
        },
        padding: 8,
        bodyFont: {
          size: 25,
          weight: "bolder",
          lineHeight: 1.5,
        },
        bodySpacing: 10,
        callbacks: {
          title: titleToolTip,
          label: labelToolTip,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          // maxTicksLimit: maxWidth500 ? 6 : maxWidth765 ? 12 : 24,
          maxRotation: 0,
          minRotation: 0,
          // min: -1,
          callback: function (value, index, values) {
            if (label[index].toString().indexOf(".") == -1) {
              return label[index];
            }
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grace: "50",
        grid: {
          display: true,
        },
        ticks: {
          callback: function (value) {
            return value + "RT";
          },
        },
      },
    },
  };
};

export const data = (data, label) => {
  return {
    labels: label,
    datasets: [
      {
        // label: "Dataset 1",
        // data: labels.map(() => faker.datatype.number({ min: 0, max: 1500 })),
        data: data,
        // data: [18, 12, 6, 9, 12, 3, 9],
        borderColor: "#00A6EF",
        pointBackgroundColor: "#F9A825",
        pointBorderColor: "white",
        pointHoverRadius: 10,
        pointHoverBackgroundColor: "#F9A825",
        pointHoverBorderColor: "white",
        tension: 0.4,
        backgroundColor: "rgba(0, 166, 239, 0.2)",
        fill: true,
      },
    ],
  };
};

export const plugins = [
  {
    beforeDraw: (chart) => {
      if (chart.tooltip._active && chart.tooltip._active.length) {
        const ctx = chart.ctx;
        ctx.save();
        const activePoint = chart.tooltip._active[0];
        ctx.beginPath();
        ctx.setLineDash([5, 7]);
        ctx.moveTo(activePoint.element.x, chart.chartArea.bottom);
        ctx.lineTo(activePoint.element.x, activePoint.element.y);
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#00A6EF";
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];
